import React, { useEffect, useState } from "react";
import { CircularProgress } from "@mui/material";
import Swal from "sweetalert2";
import { setupManagementUrl } from "../../../../config";
import {
  generateAndExecuteMutation,
  graphqlQuery,
} from "../../../../data/Axios/DynamicService";
import { allInsightType } from "../../../../data/Queries/SetupManagement/FinSightsQueries";
import DynamicForm from "../../../../data/Axios/DynamicForm";

const base_url = setupManagementUrl.uri;

const InsightTypeForm = (props) => {
  const [insightData, setInsightData] = useState([]);

  const initialValues = {
    id: props.data ? props.data.id : "",
    description: props.data ? props.data.description : "",
  };

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const { description } = values;

      const mutationData = props.isEditing
        ? {
            id: props.data.id,
            description,
          }
        : {
            description,
          };

      const response = await generateAndExecuteMutation(
        props.isEditing ? "updateInsightType" : "createInsightType",
        mutationData,
        "insightType",
        base_url
      );

      if (Object.values(response)[0] != null) {
        props.onClose();
        props.onAction();

        Swal.fire({
          icon: "success",
          title: "Success!",
          text: `Insight Type ${
            props.isEditing ? "updated" : "created"
          } successfully.`,
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while processing your request. Please try again later.",
      });
    }

    setSubmitting(false);
  };

  useEffect(() => {
    async function fetchAllData() {
      try {
        const response = await graphqlQuery(allInsightType, base_url);

        if (response) {
          setInsightData(response || []);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }

    fetchAllData();
  }, []);

  const insightTypeOptions = insightData
    ? insightData.map((data) => ({
        value: data.id,
        label: data.description,
      }))
    : [];

  const fields = [
    {
      name: "description",
      label: "Description *",
      type: "text",
      gridColumn: "span 2",
      required: true,
    },
  ];

  return (
    <DynamicForm
      initialValues={initialValues}
      fields={fields}
      onSubmit={handleSubmit}
      title={props.isEditing ? "Edit Insight Type" : "Create Insight Type"}
      subtitle={
        props.isEditing
          ? "Edit an Existing Insight Type"
          : "Create a New Insight Type"
      }
    />
  );
};

export default InsightTypeForm;
